import { Injectable } from '@angular/core';
import { VzpValidateRcInput } from '@libs/types/src/services/input-type/vzp/vzp.validate-rc-input';
import { VzpValidateRcObject } from '@libs/types/src/services/object-type/vzp/vzp.validate-rc-object';
import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';

@Injectable({ providedIn: 'root' })
export class VzpGqlServiceV2 extends GqlServiceV2 {

    public validateRc(input: VzpValidateRcInput) {
        return this.query<VzpValidateRcObject>(
            `
                query($input: VzpValidateRcInput!) {
                    vzp {
                        validateRc(input: $input) {
                            insured
                            code
                            birthDate
                            sex
                        }
                    }
                }
            `,
            { input },
        );
    }

}
